import { Divider, styled } from "@mui/material";

const ProfileDivider = styled(Divider)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

export default ProfileDivider;
